import { getMercatorScale } from './getMercatorScale';

/**
 * Calculates the average Mercator scale between two latitudes.
 * This function computes the average scale factor for the Mercator projection
 * between the origin latitude and the target latitude.
 * It divides the latitude range into a specified number of steps and averages the scale factors
 * at each step to provide a more accurate representation of the scale change.
 * @param originLat
 * @param pointLat
 * @param steps
 * @returns
 */
export const averageMercatorScale = (originLat: number, pointLat: number, steps = 10): number => {
  let totalScale = 0;
  const latStep = (pointLat - originLat) / steps;
  for (let i = 0; i <= steps; i++) {
    const lat = originLat + latStep * i;
    totalScale += getMercatorScale(lat);
  }
  return totalScale / (steps + 1);
};
